export default __webpack_public_path__ + "static/media/dot.eccdeebf.svg";